var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            title: "Edit Quick Push",
            visible: _vm.dialogVisible,
            width: "65vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "padding-lr",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "140px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "", prop: "" } }, [
                _c("p", { staticClass: "right-find" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(
                    "请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站： "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.rightfind.com",
                        target: "_blank",
                      },
                    },
                    [_vm._v("https://www.rightfind.com")]
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Greetings", prop: "greeting" } },
                [
                  _c("el-input", {
                    staticClass: "greet-input",
                    attrs: {
                      placeholder: "Please input greetings",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.greeting,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "greeting", $$v)
                      },
                      expression: "form.greeting",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  ref: "pushToMSL",
                  attrs: { label: "Push to Me", prop: "pushToMSL" },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.disablePushToMSL },
                          model: {
                            value: _vm.form.pushToMSL,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pushToMSL", $$v)
                            },
                            expression: "form.pushToMSL",
                          },
                        },
                        [_vm._v("Push to Me")]
                      ),
                      _vm.disablePushToMSL
                        ? _c(
                            "el-button",
                            {
                              staticClass: "bind-wechat-link",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.bindWeChat()
                                },
                              },
                            },
                            [_vm._v(" Bind WeChat? ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "push-to-msl-msg",
                      attrs: { slot: "error" },
                      slot: "error",
                    },
                    [_vm._v(_vm._s(_vm.pushToMSLMsg))]
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.formItemLabel, prop: "seIds" } },
                [
                  _vm.isSupervisor || _vm.isMSL
                    ? _c(
                        "el-radio-group",
                        {
                          on: { input: _vm.changeSeType },
                          model: {
                            value: _vm.seType,
                            callback: function ($$v) {
                              _vm.seType = $$v
                            },
                            expression: "seType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "All" } }, [
                            _vm._v("All"),
                          ]),
                          _c("el-radio", { attrs: { label: "SE" } }, [
                            _vm._v("SE"),
                          ]),
                          _c("el-radio", { attrs: { label: "CE" } }, [
                            _vm._v("CE"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("SEMultipleSelect", {
                    attrs: {
                      showTips: true,
                      placeholder: _vm.selectPlaceholder,
                      options: _vm.seListByType,
                      type: "quickPush",
                    },
                    on: { "select-change": _vm.onSESelectChange },
                    model: {
                      value: _vm.form.seIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "seIds", $$v)
                      },
                      expression: "form.seIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Title", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input title",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Business Purpose",
                    prop: "businessPurposeId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Please select business purpose" },
                      model: {
                        value: _vm.form.businessPurposeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "businessPurposeId", $$v)
                        },
                        expression: "form.businessPurposeId",
                      },
                    },
                    _vm._l(_vm.businessPurposeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.Name, value: item.Id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Security Level", prop: "levelId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Please select security level" },
                      model: {
                        value: _vm.form.levelId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "levelId", $$v)
                        },
                        expression: "form.levelId",
                      },
                    },
                    _vm._l(_vm.securityLevelsList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.Name, value: item.Id },
                      })
                    }),
                    1
                  ),
                  _c("p", { staticClass: "security-level" }, [
                    _c("i", { staticClass: "el-icon-warning-outline" }),
                    _vm._v("本平台禁止传输Orange/Red CCI文件 "),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Request", prop: "inquiry" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input request",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.inquiry,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "inquiry", $$v)
                      },
                      expression: "form.inquiry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "VV Number", prop: "vvNumber" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input vv number",
                      maxlength: "40",
                    },
                    model: {
                      value: _vm.form.vvNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "vvNumber", $$v)
                      },
                      expression: "form.vvNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Upload file" } },
                [
                  _c("MultipleFileUpload", {
                    ref: "fileUpload",
                    attrs: {
                      action: "/quickPush/uploadFile",
                      accept: ".PDF,.pdf,.docx,doc,.ppt,.pptx",
                      message: "Only PDF, Doc and PPT file can be uploaded",
                    },
                    on: { success: _vm.onFileUpload },
                  }),
                  _c(
                    "ul",
                    { staticClass: "upload-files" },
                    _vm._l(_vm.files, function (file, i) {
                      return _c(
                        "li",
                        { key: i, staticClass: "upload-file-item" },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: file.previewUrl,
                                target: "_blank",
                                title: file.originalName,
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-document" }),
                              _vm._v(" " + _vm._s(file.originalName) + " "),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFile(i)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "editor",
                  attrs: { label: "Content", prop: "paperContent" },
                },
                [
                  _vm.visible
                    ? _c("TinymceEditor", {
                        attrs: { height: 200 },
                        model: {
                          value: _vm.form.paperContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "paperContent", $$v)
                          },
                          expression: "form.paperContent",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.previewing },
                  on: { click: _vm.onPreview },
                },
                [_vm._v(" " + _vm._s(_vm.previewLabel) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.actionDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit(1)
                    },
                  },
                },
                [_vm._v(" Submit ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.actionDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit(0)
                    },
                  },
                },
                [_vm._v(" Save Draft ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("QRCodeDialog", {
        attrs: { visible: _vm.qrcodeDialogVisible, data: _vm.previewUrl },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.previewUrl = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }